import { render } from "./FormularioFuncionario.vue?vue&type=template&id=684c415b&scoped=true"
import script from "./FormularioFuncionario.vue?vue&type=script&lang=js"
export * from "./FormularioFuncionario.vue?vue&type=script&lang=js"

import "./FormularioFuncionario.vue?vue&type=style&index=0&id=684c415b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-684c415b"]])

export default __exports__